import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';
import { useSalesOrderForFulfillmentId } from '../../../hooks/entities/selectors/fulfillments';

const Source = ({ fulfillmentId }) => {
  const salesOrder = useSalesOrderForFulfillmentId(fulfillmentId);
  const { originalSource } = salesOrder ?? {};

  return originalSource ?? '';
};

Source.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const source = {
  getMessageDescriptor: () => messages.source,
  name: <FormattedMessage {...messages.source} />,
  id: 'source',
  render: (data) => <Source fulfillmentId={data.id} />,
};
